var cultureScale = {
    base: {
        overflow: "visible",
        my: "6px",
        // follow reach ui pattern to customise child's style using attribute instead of className
        "[data-culture-scale-marker]": { stroke: "black.20", strokeWidth: 1 },
        "[data-culture-scale-meter]": { overflow: "visible" },
        "[data-culture-scale-join]": {
            stroke: "black.70",
        },
        "[data-culture-scale-indicator]": {
            stroke: "black.40",
            fill: "black.40",
            strokeWidth: 1,
        },
        "[data-culture-scale-indicator-pointer]": {
            strokeWidth: 0,
        },
        "[data-culture-scale-node]": {
            stroke: "black.70",
            strokeWidth: 1,
            "&[data-tone=white]": {
                fill: "white",
            },
            "&[data-tone=black]": {
                fill: "black.70",
            },
        },
    },
    variants: {
        tone: {
            white: {
                "[data-culture-scale-background]": {
                    fill: "black.3",
                },
            },
            primary: {
                "[data-culture-scale-background]": {
                    fill: "primary.10",
                },
            },
        },
    },
};

export { cultureScale };
//# sourceMappingURL=culture-scale.js.map
